import {
  Button,
  MenuItem,
  TextField,
  Select,
  FormControl,
  InputLabel,
  Box,
} from "@material-ui/core";
import { observer } from "mobx-react";
import React, { Fragment, useState, useEffect } from "react";
import Confirm from "../../components/Confirm";
import adminStore from "../../stores/adminStore";
import DataTable from "./../../components/DataTable";

@observer
class Questions extends React.Component {
  state = {
    mode: "list",
    isConfirmOpened: false,
    activeQuestion: {
      competence: {},
      answers: [],
    },
    activeAnswer: {},
  };

  reset() {
    this.setState({
      mode: "list",
      isConfirmOpened: false,
      activeQuestion: {
        competence:
          adminStore.competences.length > 0 ? adminStore.competences[0] : {},
        answers: [],
      },
      activeAnswer: {},
    });
  }

  render() {
    const { questions, competences } = adminStore;
    if (!questions) {
      return <div></div>;
    }
    return (
      <Fragment>
        <Confirm
          isOpen={this.state.isConfirmOpened}
          onNo={() => this.reset()}
          onYes={async () => {
            await adminStore.deleteQuestion(this.state.activeQuestion.id);
            this.reset();
          }}
          onClose={() => this.reset()}
          title="Atencion"
          text={`Esta accion borrar a la pregunta ID: ${this.state.activeQuestion.id}, desea continuar?`}
        />
        {this.state.mode === "list" && (
          <Fragment>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                this.reset();
                this.setState({
                    ...this.state,
                  mode: "form",
                });
              }}
            >
              Nueva pregunta
            </Button>
            <DataTable
              data={questions || []}
              fields={["id", "title", "description"]}
              fieldNames={{
                id: "#",
                title: "Titulo",
                description: "Descripcion",
              }}
              onEdit={(question) => {
                this.setState({
                    ...this.state,
                  activeQuestion: { ...question },
                  mode: "form",
                });
              }}
              onDelete={(question) =>
                this.setState({
                    ...this.state,
                  isConfirmOpened: true,
                  activeQuestion: question,
                })
              }
            />
          </Fragment>
        )}
        {this.state.mode === "form" && (
          <Fragment>
            <Button variant="contained" onClick={() => this.reset()}>
              Volver
            </Button>
            <QuestionForm
              deleteAnswer={async (answer) => {
                await adminStore.deleteAnswer(answer.id);
                this.setState({
                    ...this.state,
                  activeQuestion: {
                    ...this.state.activeQuestion,
                    answers: [...this.state.activeQuestion.answers].filter(
                      (a) => a.id !== answer.id
                    ),
                  },
                });
              }}
              changeState={(...args) => this.setState(...args)}
              onSubmit={async (question) => {
                await adminStore.submitQuestion({
                  ...question,
                  competence_id: question.competence.id,
                });
                this.reset();
              }}
              question={{ ...this.state.activeQuestion }}
              competences={competences}
            />
          </Fragment>
        )}
        {this.state.mode === "answer" && (
          <Fragment>
            <Button
              variant="contained"
              onClick={() => this.setState({ ...this.state, mode: "form" })}
            >
              Volver
            </Button>
            <AnswerForm
              onSubmit={async (a) => {
                const ans = await adminStore.submitAnswer({
                  ...a,
                  question_id: this.state.activeQuestion.id,
                });
                let newAnswers = [...this.state.activeQuestion.answers]
                if(!a.id){
                    newAnswers.push(ans)
                } else {
                    let idx = 0
                    for(let x of this.state.activeQuestion.answers){
                        if(x.id === a.id){
                            break
                        }
                        idx++;
                    }
                    newAnswers[idx] = ans
                }
                this.setState({
                  ...this.state,
                  mode: "form",
                  activeQuestion: {
                    ...this.state.activeQuestion,
                    answers: newAnswers,
                  },
                });
              }}
              answer={this.state.activeAnswer}
            />
          </Fragment>
        )}
      </Fragment>
    );
  }
}

export { Questions };

const QuestionForm = ({
  question,
  onSubmit,
  competences,
  changeState,
  deleteAnswer,
}) => {
  const [form, setForm] = useState({});

  useEffect(() => {
    setForm(question);
  }, [question]);

  return (
    <Fragment>
      <Button
        variant="contained"
        color="primary"
        onClick={() => onSubmit(form)}
        disabled={
            !form.title ||
            !form.description ||
            !form.competence.id
        }
      >
        Guardar
      </Button>
      <Box m={2} />
      <TextField
        autoComplete="title"
        name="title"
        variant="outlined"
        required
        fullWidth
        id="title"
        label="Titulo"
        value={form.title}
        onChange={({ target }) => setForm({ ...form, title: target.value })}
        autoFocus
      />
      <Box m={1} />
      <TextField
        multiline={true}
        rows={10}
        autoComplete="description"
        name="description"
        variant="outlined"
        required
        fullWidth
        id="description"
        label="Descripcion"
        value={form.description}
        onChange={({ target }) =>
          setForm({ ...form, description: target.value })
        }
        autoFocus
      />
      <Box m={1} />
      {form.competence && (
        <FormControl>
          <InputLabel shrink>Competencia</InputLabel>
          <Select
            value={form.competence.id}
            onChange={({ target }) =>
              setForm({
                ...form,
                competence: { ...form.competence, id: target.value },
              })
            }
            displayEmpty
          >
            {competences.map((c) => (
              <MenuItem value={c.id}>{c.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
      <Box m={2} />
{ form.id && <Fragment>    <h2>Respuestas</h2>
      <Box m={1} />
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          changeState({
            mode: "answer",
            activeAnswer: {},
          });
        }}
      >
        Nueva respuesta
      </Button>
      <Box m={1} />
      <DataTable
        data={form.answers || []}
        fields={["id", "description", "score"]}
        fieldNames={{
          id: "#",
          description: "Descripcion",
          score: "Puntaje",
        }}
          onEdit={(answer) => {
              changeState({
                  activeQuestion: form,
                  mode: "answer",
                  activeAnswer: answer,
              })
          }}
        onDelete={(a) => deleteAnswer(a)}
      /> </Fragment>}
    </Fragment>
  );
};

const AnswerForm = ({ answer, onSubmit }) => {
  const [form, setForm] = useState({});

  useEffect(() => {
    setForm(answer);
  }, [answer]);
  console.log(form.score, typeof form.score)
  return (
    <Fragment>
      <Button
        variant="contained"
        color="primary"
        onClick={() => onSubmit(form)}
        disabled={
            !form.description ||
            !form.score ||
            Number.isNaN(Number(form.score))
        }
      >
        Guardar
      </Button>
      <Box m={2} />
      <Box m={1} />
      <TextField
        multiline={true}
        rows={10}
        autoComplete="description"
        name="description"
        variant="outlined"
        required
        fullWidth
        id="description"
        label="Descripcion"
        value={form.description}
        onChange={({ target }) =>
          setForm({ ...form, description: target.value })
        }
        autoFocus
      />
      <Box m={1} />
      <TextField
        type={"number"}
        rows={10}
        autoComplete="score"
        name="score"
        variant="outlined"
        required
        fullWidth
        id="score"
        label="Puntaje"
        value={form.score}
        onChange={({ target }) => setForm({ ...form, score: target.value })}
        autoFocus
      />
    </Fragment>
  );
};
